import React, { useState, createContext } from "react";

export const OutputContext = createContext();

export const OutputProvider = ({ children }) => {
  const [outputs, setOutputs] = useState([]);
  const [loading, setLoading] = useState(true)

  const updateOutputs = (newOutputs) => {
    setOutputs(newOutputs);
  };

  return (
    <OutputContext.Provider value={{ outputs, updateOutputs, loading, setLoading }}>
      {children}
    </OutputContext.Provider>
  );
};
